import { PageTitle } from "@/components/pageTitle";

export const Access = () => {
  return (
    <div className="flex justify-center">
      <div className="pt-[50px] px-[240px] w-[1920px]">
        <PageTitle title="全球个链路优质资源，轻松接入" />
        <div className="flex justify-between mt-[110px]">
          <Item
            img={"/imgs/private/Frame.png"}
            title="光年全球骨干网络"
            content1="POP点覆盖50多个国家/地区"
            content2="全球各地纯净IP资源地"
          />
          <Item
            img={"/imgs/private/Frame-1.png"}
            title="运营商合作伙伴"
            content1="国际专线均来自运营商"
            content2="安全审计合法合规"
          />
          <Item
            img={"/imgs/private/Frame-2.png"}
            title="主流云平台"
            content1="优质网络资源快速接入"
            content2="价格优惠稳定可靠"
          />
        </div>

        <div className="flex justify-center mt-[110px]">
          <a
            href="https://t22qshgkpd.jiandaoyun.com/f/68cb7a5580eabb69297c524b"
            target="_blank"
          >
            <div className="w-[432px] h-[63px] rounded-[10px] border-2 border-[#3E9DFF] flex items-center cursor-pointer justify-center">
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[31px] text-[#3E9DFF] flex items-center gap-[10px]">
                立即咨询，获取解决方案{" "}
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24.5 14H3.5"
                    stroke="#3E9DFF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M17.5 7L24.5 14L17.5 21"
                    stroke="#3E9DFF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
          </a>
        </div>

        <div className="flex justify-between mt-[110px]">
          <ImgItem img={"/imgs/private/11.png"} title="智慧安防" />
          <ImgItem img={"/imgs/private/12.png"} title="IT互联网" />
          <ImgItem img={"/imgs/private/13.png"} title="智慧交通" />
        </div>
        <div className="flex justify-between mt-[30px]">
          <ImgItem img={"/imgs/private/14.png"} title="智慧医疗" />
          <ImgItem img={"/imgs/private/15.png"} title="零售连锁" />
          <ImgItem img={"/imgs/private/16.png"} title="智能酒店" />
        </div>
        <div className="flex justify-between mt-[30px]">
          <ImgItem img={"/imgs/private/17.png"} title="智慧教育" />
          <ImgItem img={"/imgs/private/18.png"} title="智能制造" />
          <ImgItem img={"/imgs/private/19.png"} title="远程办公" />
        </div>
        <a
          href="https://t22qshgkpd.jiandaoyun.com/f/68cb7a5580eabb69297c524b"
          target="_blank"
        >
          <div className="flex justify-center mt-[100px] cursor-pointer">
            <div className="w-[340px] h-[63px] bg-gradient-to-br from-[#0464FF] to-[#5F97FF] rounded-[10px] flex items-center justify-center gap-[10px] font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[25px] text-white">
              查看解决方案详情
              <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M24.5 14H3.5"
                  stroke="#ffffff"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M17.5 7L24.5 14L17.5 21"
                  stroke="#ffffff"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        </a>
        <div className="h-[150px] w-full " />
      </div>
    </div>
  );
};

export const Item = (props: {
  title: string;
  content1: string;
  content2: string;
  img: string;
}) => {
  return (
    <div className="w-[460px] h-[194px] bg-white shadow-[0px_4px_14px_0px_rgba(0,0,0,0.12)] rounded-[20px] pt-[30px] px-[20px] flex gap-[23px]">
      <div className="flex-1 ">
        <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[26px] text-[#333333]">
          {props.title}
        </div>
        <div className="mt-[30px]">
          <div className="flex items-center gap-[12px]">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_18031_7799)">
                <path
                  d="M0 12C0 5.37269 5.37269 0 12 0C18.6273 0 24 5.37269 24 12C24 18.6273 18.6273 24 12 24C5.37269 24 0 18.6273 0 12ZM9.82759 16.5617C9.97832 16.7171 10.184 16.8073 10.4004 16.8128C10.6168 16.8184 10.8269 16.7389 10.9854 16.5914L18.8491 9.28055C19.0087 9.13083 19.1024 8.92402 19.1099 8.70535C19.1174 8.48668 19.038 8.27394 18.889 8.11367C18.7401 7.9534 18.5337 7.85863 18.3151 7.8501C18.0964 7.84157 17.8833 7.91996 17.7223 8.06814L10.4772 14.8543L7.07586 11.347C7.00045 11.268 6.91012 11.2046 6.81009 11.1606C6.71007 11.1167 6.60232 11.0929 6.49308 11.0908C6.38383 11.0887 6.27525 11.1082 6.17359 11.1483C6.07193 11.1883 5.97921 11.2481 5.90078 11.3242C5.82235 11.4003 5.75977 11.4912 5.71663 11.5915C5.6735 11.6919 5.65068 11.7999 5.64947 11.9091C5.64827 12.0184 5.66872 12.1268 5.70964 12.2281C5.75055 12.3295 5.81113 12.4217 5.88786 12.4994L9.828 16.5617H9.82759Z"
                  fill="#74B9FF"
                />
              </g>
              <defs>
                <clipPath id="clip0_18031_7799">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[18px] text-[#003366]">
              {props.content1}
            </div>
          </div>
          <div className="flex items-center gap-[12px]">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_18031_7799)">
                <path
                  d="M0 12C0 5.37269 5.37269 0 12 0C18.6273 0 24 5.37269 24 12C24 18.6273 18.6273 24 12 24C5.37269 24 0 18.6273 0 12ZM9.82759 16.5617C9.97832 16.7171 10.184 16.8073 10.4004 16.8128C10.6168 16.8184 10.8269 16.7389 10.9854 16.5914L18.8491 9.28055C19.0087 9.13083 19.1024 8.92402 19.1099 8.70535C19.1174 8.48668 19.038 8.27394 18.889 8.11367C18.7401 7.9534 18.5337 7.85863 18.3151 7.8501C18.0964 7.84157 17.8833 7.91996 17.7223 8.06814L10.4772 14.8543L7.07586 11.347C7.00045 11.268 6.91012 11.2046 6.81009 11.1606C6.71007 11.1167 6.60232 11.0929 6.49308 11.0908C6.38383 11.0887 6.27525 11.1082 6.17359 11.1483C6.07193 11.1883 5.97921 11.2481 5.90078 11.3242C5.82235 11.4003 5.75977 11.4912 5.71663 11.5915C5.6735 11.6919 5.65068 11.7999 5.64947 11.9091C5.64827 12.0184 5.66872 12.1268 5.70964 12.2281C5.75055 12.3295 5.81113 12.4217 5.88786 12.4994L9.828 16.5617H9.82759Z"
                  fill="#74B9FF"
                />
              </g>
              <defs>
                <clipPath id="clip0_18031_7799">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[18px] text-[#003366]">
              {props.content2}
            </div>
          </div>
        </div>
      </div>
      <img className="w-[120px] h-[120px] " src={props.img} />
    </div>
  );
};

export const ImgItem = (props: { img: string; title: string }) => {
  return (
    <div className="flex flex-col items-center">
      <img className="w-[406px] h-[248px]" src={props.img} />
      <div className=" relative mt-[30px]">
        <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[24px] text-[#333333] z-10 relative">
          {props.title}
        </div>
        <div
          className="w-[81px] h-[8px] absolute bottom-[2px] left-[40px] z-1"
          style={{
            backgroundImage:
              "linear-gradient(90deg, #FFFFFF 0%, #BFD6FF 25%, #5F97FF 50.48%, #B0CCFF 74.52%, #FFFFFF 100%)",
          }}
        ></div>
      </div>
    </div>
  );
};
